import React, { Component } from 'react';
import LoadingBar from '../../components/global/loadingBar';
import { ReactComponent as Back } from '../../../assets/svg/chevron-left.svg';
import { ReactComponent as Delete } from '../../../assets/svg/delete.svg';
import InputHeader from '../../components/global/inputwithHeader';
import { gql } from '@apollo/client';
import ProjectsGraphQl from '../../../controllers/projectsGraphQl';
import { withRouter } from '../../../services/withRoute';
import _ from 'lodash';
import Select from 'react-select';
import equipmentConstants from '../../../utils/equipmentConstants';
var randomize = require('randomatic');

const registerMC = gql`
	mutation RegisterVendorMC($branchId: String!, $memoryCardInput: RegisterMcInput) {
		registerVendorMC(branchId: $branchId, memoryCardInput: $memoryCardInput) {
			message
		}
	}
`;

const getMemoryCardInfo = gql`
	query MemoryCard($mcIdentifier: String) {
		memoryCard(mcIdentifier: $mcIdentifier) {
			id
			manufacturer
			manufacturerId
			qrCode
			status
			description
			type
		}
	}
`;

const getBranchList = gql`
	query BranchesList {
		branchesList {
			id
			code
			branchId
			description
			address
			city
			state
		}
	}
`;

class RegisterMemoryCard extends ProjectsGraphQl {
	constructor() {
		super();
		this.state = {
			isLoading: true,
			qrCode: '',
			isEQFetching: false,
			mcs: [],
			type: null,
			size: null,
			manufacturer: null,
			serialNumber: null,
			comment: null,
			branchId: null,
			uploadBatchID: randomize('Aa0', 10),
			files: [],
			notes: null,
			qrCodeError: false,
			qrCodeErrorMessage: '',
			typeOptionsList: equipmentConstants.memoryCard.types,
			manufacturerOptionsList: equipmentConstants.memoryCard.manufacturers,
			sizeOptionsList: equipmentConstants.memoryCard.sizes,
		};
	}

	componentDidMount = () => {
		this.getBranchList(getBranchList);
	};

	isDisabled = () => {
		if (
			_.size(this.state.mcs) == 0 ||
			this.state.branchId === null ||
			_.size(this.state.mcs) !==
				_.size(this.state.mcs.filter((mc) => mc.qr !== null || mc.qr !== undefined)) ||
			_.size(this.state.mcs) !== _.size(this.state.mcs.filter((mc) => mc.type !== null)) ||
			_.size(this.state.mcs) !== _.size(this.state.mcs.filter((mc) => mc.size !== null)) ||
			_.size(this.state.mcs) !==
				_.size(this.state.mcs.filter((mc) => mc.manufacturer !== null)) ||
			_.size(this.state.mcs) !==
				_.size(this.state.mcs.filter((mc) => mc.serialNumber !== null)) ||
			_.size(this.state.mcs) !== _.size(this.state.mcs.filter((mc) => mc.comment !== null))
		) {
			return true;
		} else {
			return false;
		}
	};
	handleRegisterMCs = (e) => {
		let mcs = _.map(this.state.mcs, (mc, key) => {
			mc = {
				...mc,
				description: `${mc.manufacturer} ${mc.size} ${mc.type}`,
				manufacturerId: mc.serialNumber,
			};
			delete mc.serialNumber;
			return mc;
		});
		let json = {
			branchId: this.state.branchId,
			memoryCardInput: {
				/* notes: {
					message: this.state.notes,
				}, */
				memoryCards: mcs,
				files: this.state.files,
				batchId: this.state.uploadBatchID,
			},
		};

		this.registerAssets(registerMC, json, 'memorycards');
	};
	handleQrCode = async (e, type) => {
		this.setState({
			qrCode: e.target.value.toUpperCase(),
			qrCodeError: false,
			qrCodeErrorMessage: '',
		});
		if (e.target.value !== '' && e.target.value.length >= 8) {
			if (_.size(_.filter(this.state.mcs, { qrCode: e.target.value })) > 0) {
				this.setState({
					qrCodeError: true,
					qrCodeErrorMessage: 'Memory Card already scanned',
				});
			} else if (
				await this.getMemoryCardInfo(
					getMemoryCardInfo,
					{
						mcIdentifier: e.target.value,
					},
					null,
					true,
				)
			) {
				this.setState({
					qrCodeError: true,
					qrCodeErrorMessage: 'QRCODE already registered',
				});
			} else {
				let mcs = this.state.mcs;
				let json = { qrCode: e.target.value };
				if (this.state.type !== null) {
					json = { ...json, type: this.state.type };
				}
				if (this.state.size !== null) {
					json = { ...json, size: this.state.size };
				}
				if (this.state.manufacturer !== null) {
					json = { ...json, manufacturer: this.state.manufacturer };
				}
				if (this.state.serialNumber !== null) {
					json = { ...json, serialNumber: this.state.serialNumber };
				}
				if (this.state.comment !== null) {
					json = { ...json, comment: this.state.comment };
				}

				mcs.push(json);
				this.setState({
					mcs,
					qrCode: '',
				});
			}
		}
	};
	handleInput = async (e, type, key) => {
		let value = _.has(e, 'target') ? e.target.value : e.value;
		if (key == 0) {
			this.setState({
				[type]: value,
			});

			if (type !== 'serialNumber' && type != 'comment') {
				let mcs = this.state.mcs;
				const updatedMcs = mcs.map((mc) => ({
					...mc,
					[type]: value,
				}));

				this.setState({ mcs: updatedMcs });
			} else {
				let mcs = _.cloneDeep(this.state.mcs);
				mcs[0][type] = value;

				this.setState({ mcs });
			}
		} else {
			let mcs = this.state.mcs;
			mcs[key] = { ...this.state.mcs[key], [type]: value };
			this.setState({
				mcs,
			});
		}
	};
	deleteItem = (e, qrCode) => {
		let mcs = [...this.state.mcs];
		this.setState({
			mcs: _.filter(mcs, function (o) {
				return o.qrCode !== qrCode;
			}),
		});
	};

	handleBranchChange = (e) => {
		this.setState({
			branchId: e.value,
		});
	};

	renderMemoryCardTable = () => {
		return (
			<div className="qrCodeTable">
				<div className="header">
					<span>qr code *</span>
					<span>Type *</span>
					<span>Size *</span>
					<span>manufacturer</span>
					<span>serial Number</span>
					<span>Comments</span>
					<span></span>
				</div>
				{_.map(this.state.mcs, (mc, key) => {
					return (
						<div className="row">
							<span>{mc.qrCode}</span>
							<span className="mc-reg">
								<Select
									key={mc.type}
									className={`cost-select-container cost-select-container-eq ${
										'zIndex' + (30 - key)
									} w-100p`}
									classNamePrefix="cost-select"
									options={this.state.typeOptionsList}
									onChange={(e) => this.handleInput(e, 'type', key)}
									isSearchable={true}
									defaultValue={_.find(this.state.typeOptionsList, {
										value: mc.type,
									})}
								/>
							</span>
							<span className="mc-reg">
								{/* <input
                                    value={mc.size}
                                    onChange={(e) =>
                                        this.handleInput(e, 'size', key)
                                    }
                                /> */}
								<Select
									key={mc.size}
									className={`cost-select-container cost-select-container-eq ${
										'zIndex' + (30 - key)
									} w-100p`}
									classNamePrefix="cost-select"
									options={this.state.sizeOptionsList}
									onChange={(e) => this.handleInput(e, 'size', key)}
									isSearchable={true}
									defaultValue={_.find(this.state.sizeOptionsList, {
										value: mc.size,
									})}
								/>
							</span>
							<span className="mc-reg">
								<Select
									key={mc.manufacturer}
									className={`cost-select-container cost-select-container-eq ${
										'zIndex' + (30 - key)
									} w-100p`}
									classNamePrefix="cost-select"
									options={this.state.manufacturerOptionsList}
									onChange={(e) => this.handleInput(e, 'manufacturer', key)}
									isSearchable={true}
									defaultValue={_.find(this.state.manufacturerOptionsList, {
										value: mc.manufacturer,
									})}
								/>
							</span>
							<span>
								<input
									value={mc.serialNumber}
									onChange={(e) => this.handleInput(e, 'serialNumber', key)}
								/>
							</span>
							<span>
								<input
									value={mc.comment}
									onChange={(e) => this.handleInput(e, 'comment', key)}
								/>
							</span>
							<span onClick={(e) => this.deleteItem(e, mc.qrCode)}>
								<Delete />
							</span>
						</div>
					);
				})}
			</div>
		);
	};

	renderMemoryCardTableComponent = () => {
		return (
			<>
				{_.size(this.state.mcs) > 0 ? (
					this.renderMemoryCardTable()
				) : (
					<div className="empty-mcs">
						No Mc Added <br /> Please scan or type in the equipment ID
					</div>
				)}
			</>
		);
	};
	render() {
		return (
			<>
				{this.state.isLoading ? (
					<div
						style={{
							position: 'relative',
							height: 'calc(100vh - 102px)',
							width: 'calc(100vw - 403px)',
						}}
					>
						<LoadingBar />
					</div>
				) : (
					<div
						className="assign-receive-container"
						style={{ width: '100%', marginLeft: 0 }}
					>
						<div className="arc-header">
							<div className="back-btn" onClick={(e) => this.goBack(e)}>
								<Back />
							</div>
							<div className="arch-item">
								<span>Admin Tools</span>
							</div>
							<div className="next-btn">
								{' '}
								<Back />
							</div>

							<div className="arch-item">
								<span>Register Memory Card</span>
							</div>
							<div className="actn-btn">
								<a
									onClick={(e) => {
										if (!this.isDisabled()) {
											this.handleRegisterMCs(e);
										}
									}}
									className={this.isDisabled() ? 'isDisabledBtn' : ''}
								>
									Register{' '}
									{_.size(this.state.mcs) > 0 ? _.size(this.state.mcs) + ' ' : ''}
									Memory Cards
								</a>
							</div>
						</div>
						<div className="arc-body">
							<div className="remap-equipment-container">
								<div className="rec-left">
									<div
										className="floating-select-container"
										style={{ marginBottom: '30px' }}
									>
										<label>
											Branch
											<span className="required-star">*</span>
										</label>
										{this.state.branchId === null || this.state.branchId ? (
											<Select
												key={_.size(this.state.branchesListOption)}
												className={
													'cost-select-container zIndex31 w-100p' +
													(this.state.isSuspended
														? ' cost-select--is-disabled'
														: '')
												}
												classNamePrefix="cost-select"
												options={this.state.branchesListOption}
												onChange={(e) => this.handleBranchChange(e)}
												value={_.find(this.state.branchesListOption, {
													value: this.state.branchId,
												})}
												defaultValue={_.find(
													this.state.branchesListOption,
													{
														value: this.state.branchId,
													},
												)}
												isDisabled={this.state.isSuspended}
												isSearchable={true}
											/>
										) : null}
									</div>
									<input
										className="qrcode"
										value={this.state.qrCode}
										placeholder="Type QR Code"
										autoFocus={true}
										onChange={(e) => this.handleQrCode(e, 'qrCode')}
										disabled={this.state.isEQFetching}
									/>
									{this.state.isEQFetching ? (
										<div className={'loading-btn'}>
											<LoadingBar />
										</div>
									) : (
										''
									)}
									{this.state.qrCodeError ? (
										<p
											style={{
												color: 'red',
												fontSize: 13,
											}}
										>
											{this.state.qrCodeErrorMessage}
										</p>
									) : (
										''
									)}
									{this.renderMemoryCardTableComponent()}
								</div>
							</div>
						</div>
					</div>
				)}
			</>
		);
	}
}

export default withRouter(RegisterMemoryCard);
